import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const FileCsvIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fill-rule="evenodd">
        <path fill="#0099E8" d="M0 0h48v48H0z" />
        <path fill="#FFF" d="M38 16H10v-6h28zM38 26H10v-6h28zM30 36H10v-6h20z" />
      </g>
    </SvgIcon>
  );
};
